export default __webpack_public_path__ + "static/media/latest-news-img17.db6fd58d.jpg";